<template>
<div class="floordownload">
  <div class="floordownload-btn" @click="openOfficial">
    下载CC加速器，立即体验&nbsp;&nbsp;&nbsp;
    <i class="fa fa-chevron-right" aria-hidden="true"></i>
    <i class="fa fa-chevron-right" aria-hidden="true"></i>
  </div>
</div>
</template>

<script>
export default {
  name: 'Floordownload',
  methods: {
    openOfficial () {
      this.$parent.openOfficial()
    }
  }
}
</script>

<style scoped lang="scss">
.floordownload{
  position: fixed;
  left: 0px;
  right: 0px;
  bottom: 27px;
  display: flex;
  justify-content: center;
  .floordownload-btn{
    padding: 11px 15px;
    background: linear-gradient(90deg, #2992FF, #00F2C2);
    border-radius: 20px;
    font-size: 14px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #FFFFFF;
  }
}

</style>
